/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { createContext, PropsWithChildren, ReactNode, useContext } from 'react'
import { QueryOptions, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { Outlet } from 'react-router-dom'

const RouteLoaderDataContext = createContext(null)

export function useRouteLoaderData<T> () {
  return useContext<T>(RouteLoaderDataContext)
}

export type RouteLoaderDataProps<T> = PropsWithChildren
  & Required<Pick<QueryOptions, 'queryKey'>>
  & {
  fallback?: ReactNode;
  loader (args: { params: Record<string, unknown> }): Promise<T>;
}

function RouteLoaderData<T> (props: RouteLoaderDataProps<T>) {
  const { fallback, loader, queryKey } = props
  const params = useParams()

  const query = useQuery({
    enabled: true,
    queryKey,
    queryFn: () => loader({ params })
  })

  return (
    <RouteLoaderDataContext.Provider value={query.data}>
      {query.isLoading
        ? fallback
        : <Outlet />}
    </RouteLoaderDataContext.Provider>
  )
}

export default RouteLoaderData
